import React from 'react'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from '@components/ui'
import { useAppSelector } from '@store/hooks'
import type { RootState } from '@store/index'
import './NotFound.css'

const TITLE = 'Page not found'
const DESCRIPTION_AUTH =
  'The link may be outdated or mistyped. Pick a page from the sidebar, or open the dashboard.'
const DESCRIPTION_GUEST =
  'The link may be outdated or mistyped. Sign in to continue, or check the address and try again.'
const ACTION_LABEL_AUTH = 'Go to dashboard'
const ACTION_LABEL_GUEST = 'Go to login'

function NotFoundPage(): React.ReactElement {
  const navigate = useNavigate()
  const isAuthenticated = useAppSelector(
    (state: RootState) => state.auth.isAuthenticated,
  )

  const handlePrimaryAction = (): void => {
    navigate(isAuthenticated ? '/' : '/login', { replace: true })
  }

  return (
    <div className="not-found-page" role="status">
      <EmptyState
        className="not-found-page__empty"
        title={TITLE}
        description={isAuthenticated ? DESCRIPTION_AUTH : DESCRIPTION_GUEST}
        actionLabel={isAuthenticated ? ACTION_LABEL_AUTH : ACTION_LABEL_GUEST}
        onAction={handlePrimaryAction}
      />
    </div>
  )
}

export default NotFoundPage
